export class Palette {
  primaryColor: string;
  darkColor: string;
  lightColor: string;
  name?: string;
  slug?: string; // for customPalettes only

  constructor(palette?: Palette) {
    if (palette) {
      Object.assign(this, palette);
    }
  }
}
